import { css } from '@emotion/react';
import { Link,withPrefix } from 'gatsby';
import { useMemo } from 'react';
import { ButtonLink } from '@/components/shared/ButtonLink';
import { useScroll } from '@/hooks/useScroll';
import { pagesPath } from '@/lib/pagesPath';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

export type HeaderProps = {
  className?: string;
  pathname: string;
};

export const Header: React.FC<HeaderProps> = ({ className, pathname }) => {
  const { isScroll } = useScroll(100);
  const isTop = useMemo(() => pathname === '/', [pathname]);
  
  return (
    <header
      css={css`
        position: sticky;
        top: 0;
        margin-bottom: -90px;
        height: 90px;
        padding: 22px 32px 22px 64px;
        z-index: 100;
        transition: background-color 0.2s ease-out, box-shadow 0.2s ease-out;

        ${isScroll &&
        css`
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 3px 16px rgba(37, 42, 64, 0.11);
        `}
      `}
      className={className}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1480px;
          width: 100%;
          height: 100%;
          margin: 0 auto;
        `}
      >
        <div
          css={css`
            width: 21.4%; // pc-menu 最小幅での領域確保 (gap 48px相当)
            max-width: 258px; // pc-menu 最大幅での領域上限 (gap 96px相当)
          `}
        >
          {isTop ? (
            <span>
              <img
                src={withPrefix('/images/logo.svg')}
                alt="Uniforce(ユニフォース) IPO準備クラウド"
                width="174"
                height="46"
              />
            </span>
          ) : (
            <Link to={pagesPath.$url()}>
              <img
                src={withPrefix('/images/logo.svg')}
                alt="Uniforce(ユニフォース) IPO準備クラウド"
                width="174"
                height="46"
              />
            </Link>
          )}
        </div>
        <nav
          css={css`
            flex: 1 1 auto;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
            `}
          >
            <ul
              css={css`
                list-style: none;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 58%; // pc-menu 最小幅での領域確保 (gap 36px相当)
                max-width: 538px; // pc-menu 最大幅での領域上限 (gap 54px相当)
              `}
            >
              {[
                {
                  title: 'サービスの特徴',
                  to: pagesPath.features.$url(),
                },
                {
                  title: '主な機能',
                  to: pagesPath.tool.$url(),
                },
                {
                  title: '料金プラン',
                  to: pagesPath.plan.$url(),
                },
                {
                  title: 'セキュリティ',
                  to: pagesPath.security.$url(),
                },
                {
                  title: 'お知らせ',
                  to: pagesPath.news.$url(),
                },
                {
                  title: <><img src={withPrefix('/images/menu_phaseinfo.png')} alt="" width="100" /></>,
                  to: '/#phaseinfo',
                },
              ].map((item) => {
               if(item.to.match(/#/)){
                  return (
                  <li key={item.title}>
                    <AnchorLink
                      css={css`
                        text-align: left;
                        font: normal normal 500 12px/17px 'Noto Sans JP',
                          sans-serif;
                        letter-spacing: 0.09px;
                        color: #252a40;
                      `}
                      to={item.to}
                    >
                      {item.title}
                    </AnchorLink>
                  </li>
                  )
                }else{
                  return (
                  <li key={item.title}>
                    <Link
                      css={css`
                        text-align: left;
                        font: normal normal 500 12px/17px 'Noto Sans JP',
                          sans-serif;
                        letter-spacing: 0.09px;
                        color: #252a40;
                      `}
                      to={item.to}
                    >
                      {item.title}
                    </Link>
                  </li>
                  )
                }
              })}
            </ul>
            <ul
              css={css`
                align-items: center;
                display: flex;
                list-style: none;
                gap: 12px;
              `}
            >
              {[
                // リンク先が公開されるまで非表示
                // {
                //   title: 'ログイン',
                //   to: 'リンク更新',
                //   variant: 'header-login' as const,
                //   css: undefined,
                // },
                {
                  title: '相談する',
                  to: pagesPath.contact.$url(),
                  variant: 'header-demo' as const,
                  linkCss: css`
                    width: 142px;
                  `,
                },
                {
                  title: '資料請求',
                  to: pagesPath.download.$url(),
                  variant: 'header-download' as const,
                  linkCss: css`
                    width: 137px;
                  `,
                },
              ].map((item) => (
                <li key={item.title}>
                  <ButtonLink
                    css={item.linkCss}
                    to={item.to}
                    variant={item.variant}
                  >
                    {item.title}
                  </ButtonLink>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};
